import i18n from '@/i18n.js';

export const types = [
  { id: 0, name: i18n.t('ORDERS.TYPES.ALL') },
  { id: 1, name: i18n.t('EREPORTER.S') },
  { id: 2, name: i18n.t('EREPORTER.M') }
];
